import {selectScanPackSettings} from './scanPackSelectors';

export const selectToteIdentifier = state =>
  selectScanPackSettings(state)?.tote_identifier || 'Tote';

export const selectProductFirstToteSet = state =>
  state.productFirst.toteSet || state.user.userInfo?.tote_set || null;

export const selectScanPackWorkflow = state =>
  state.user.settings?.data?.scan_pack_workflow;
